import {Quest, QuestType} from '../Quest.js';
import {QuestGoal} from '../QuestGoal.js';
import {Reward} from '../Reward.js';

/**
 * Implementing the Quest interface for a KillQuest
 */
export class KillQuest extends Quest {
    questType: QuestType = QuestType.Kill;
    goal: QuestGoal;
    complete: boolean = false;
    reward: Reward;

    constructor(
        id: string,
        description: string,
        requiredAmount: number,
        target: string,
        reward: Reward,
        requiredLevel: number
    ) {
        super(id, description, requiredLevel);

        this.goal = new QuestGoal(requiredAmount, target);
        this.reward = reward;
    }

    action(name: string): void {
        if (name === this.goal.target) {
            this.goal.updateProgress();
            if (this.goal.isGoalMet()) this.onCompleted.notify();
        }
    }

    checkCompleted(): boolean {
        this.complete = this.goal.isGoalMet();
        return this.complete;
    }

    giveReward(): Reward {
        this.onRewarded.notify();
        return this.reward;
    }
}
